import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CapitalizeWithSpacesPipe, IListing, useImages } from '@out-web/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ListingTypeComponent } from '../../molecules/listing-type/listing-type.component';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'out-listing-card',
  imports: [
    CommonModule,
    RouterLink,
    ListingTypeComponent,
    CapitalizeWithSpacesPipe,
    NgOptimizedImage,
  ],
  templateUrl: './listing-card.component.html',
  styleUrl: './listing-card.component.css',
})
export class ListingCardComponent implements OnChanges {
  @Input() listing?: IListing;
  @Input() showDescription = false;
  @Input() allowEdit = false;
  sanitizedHtmlContent: SafeHtml = '';
  readonly fallbackImage = '/assets/images/fallback-image.png';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listing'] && this.listing?.content?.description) {
      this.sanitizedHtmlContent = this.sanitizer.bypassSecurityTrustHtml(
        this.listing.content.description
      );
    }
  }

  getRouterLink(): string {
    if(!this.listing)return '';
    if (
      this.allowEdit &&
      (!this.listing?.content?.images ||
        this.listing.content.images.length === 0)
    ) {
      return `/your-tesla/edit/listing/images/${this.listing.id}`;
    }

    if(this.allowEdit && !this.listing?.isPaid && (this.listing?.content?.images && this.listing.content.images.length > 0
    )){
      return `/your-tesla/listing/checkout/${this.listing.id}`
    }

    return this.allowEdit
      ? `/account/listing/${this.listing?.shortId}`
      : `/listing/${this.listing?.shortId}`;
  }

  colorGradeCarCondition(condition: string | null): string {
    const conditionColorObj = {
      Excellent: 'bg-green-50 text-green-800 px-4',
      VeryGood: 'bg-emerald-50 text-emerald-800 px-2.5',
      Good: 'bg-yellow-50 text-yellow-800 px-4',
      Fair: 'bg-orange-50 text-orange-800 px-4',
      Poor: 'bg-[#F44336]/10 text-[#F44336] px-4',
    };
    return (
      conditionColorObj[condition as keyof typeof conditionColorObj] || '#000'
    );
  }

  toggleMenu(event: { stopPropagation: () => void }) {
    event.stopPropagation();
    const menu = this.listing
      ? document.getElementById(this.listing.shortId)
      : null;
    if (menu) {
      menu.classList.toggle('!h-full');
    }
  }

  getImageUrl(): string {
    const {
      images: { featuredImage, gallery },
    } = useImages(this.listing?.content.images || []);
    if (!featuredImage) {
      return gallery.length > 0 ? gallery[0] : this.fallbackImage; // Return fallback if no gallery
    }
    return featuredImage.sizes.large || featuredImage.sizes.original;
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement | null;
    if (target) {
      target.src = this.fallbackImage;
    }
  }
}
